exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.margin-top-20[data-v-79cb688a]{\n  margin-top:20px;\n}\n.flex-end[data-v-79cb688a]{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n", ""]);

// exports
